export default {
    renderLastHeader (h, { column, $index },icon,explain) {
        let data=[
            h('i', {
                class:`icon--${icon} font-12`,
                style:'margin-right:3px;'
            }),
            h('span', column.label)
        ];
        if(explain){
            data.push(h(
                'el-tooltip',
                {
                    props: {
                        content: (function() {
                            return explain
                        })(),
                        placement: 'top'
                    }
                },
                [
                    h('span', {
                        class: {
                            'tishi_ico': true,
                            ' font-12':true
                        },
                        style:'margin-left:3px;',
                    })
                ]
            ))
        }
        return h(
            'div',data,
        )
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/tableIcons.js